<template>
  <div class="request">
    <div class="text-bold text-larger">
      <div class="row">
        <div class="col-4">Vehicle Testing Station:</div>
        <div class="col-8">{{ $store.state.vtsInfo.name }} ({{ $store.state.vtsInfo.vts_number }})</div>
      </div>
      <div class="row">
        <div class="col-4">Primary Contact:</div>
        <div class="col-8">{{ $store.state.contact.name }} ({{ $store.state.contact.email }})</div>
      </div>
    </div>
    <hr />
    <p>Each connected PC running a copy of TestWatcher requires an activation code. Please enter descriptive names for the Connected PCs you are activating, for example 'Emissions PC'.</p>
    <p>You can request up to 4 activation codes for TestWatcher. For more activations, please contact our team.</p>
    <b-form @submit="submitForm">
      <b-form-group id="connected-pc-1-group">
        <label label-for="connected-pc-1">
          Connected PC 1
          <span class="text-danger">*</span>
        </label>
        <b-form-input
          v-model="connectedPCs[0]"
          id="connected-pc-1"
          type="text"
          placeholder="Descriptive name for PC 1"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="connected-pc-2-group" label="Connected PC 2" label-for="connected-pc-2">
        <b-form-input
          v-model="connectedPCs[1]"
          id="connected-pc-2"
          type="text"
          placeholder="Descriptive name for PC 2"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="connected-pc-3-group" label="Connected PC 3" label-for="connected-pc-3">
        <b-form-input
          v-model="connectedPCs[2]"
          id="connected-pc-3"
          type="text"
          placeholder="Descriptive name for PC 3"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="connected-pc-4-group" label="Connected PC 4" label-for="connected-pc-4">
        <b-form-input
          v-model="connectedPCs[3]"
          id="connected-pc-4"
          type="text"
          placeholder="Descriptive name for PC 4"
        ></b-form-input>
      </b-form-group>

      <b-alert :show="$store.state.viewState == 'Error'" variant="danger">
        <span v-if="$store.state.error">{{ $store.state.error }}</span>
        Error processing activation, please contact our team directly who will be glad to assist.
      </b-alert>

      <b-button
        block
        size="lg"
        type="submit"
        variant="success"
        :disabled="!canSubmitActivations || isProcessing">
        Get Activation Codes
        <span class="mdi mdi-login-variant ml-2" v-if="!isProcessing"></span>
        <span class="mdi mdi-loading mdi-spin ml-2" v-if="isProcessing"></span>
      </b-button>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: "request",
  data() {
    return {
      isProcessing: false,
      connectedPCs: []
    };
  },
  computed: {
    canSubmitActivations() {
      console.log("Checking if can submit");
      return (
        this.connectedPCs &&
        this.connectedPCs.length > 0 &&
        this.connectedPCs[0].length > 0
      );
    }
  },
  methods: {
    async submitForm(e) {
      e.preventDefault();
      let activationsClean = this.connectedPCs.filter((a) => {
        return a && a.length > 0
      })
      this.isProcessing = true;
      await this.$store.dispatch("submitActivations", activationsClean);
      this.$router.push({ name: "activate-codes" });
      this.isProcessing = false;
    }
  }
};
</script>